import { useState } from 'react';

const faqs = [
  {
    q: 'Lightbox Nedir?',
    a: 'Lightbox, içten aydınlatmalı reklam ve tanıtım ürünüdür. Alüminyum veya plastik çerçeve içine yerleştirilen LED ışık kaynağı sayesinde, üzerine baskılı görsel veya metin gece gündüz net bir şekilde görünür hale gelir. Mağaza tabelaları, reklam panoları ve yönlendirme sistemlerinde yaygın olarak kullanılır.',
  },
  {
    q: 'Lightbox Tabela Ömrü Ne Kadar?',
    a: 'Kaliteli alüminyum kasa ve LED teknolojisi ile üretilen lightboxlar 10 yıl ve üzerinde sorunsuz kullanılabilir. LED ışık kaynakları 50.000 saate kadar ömre sahiptir. Düzenli bakım ile çok daha uzun süre kullanılabilmektedir.',
  },
  {
    q: 'Dış Mekanda Kullanıma Uygun mu?',
    a: 'Evet, IP65 sertifikalı dış mekan lightbox modellerimiz yağmur, kar, toz ve UV ışınlarına karşı tam koruma sağlar. -20°C ile +60°C arasında sorunsuz çalışır. Dış mekan modeller iç mekana kıyasla daha sağlam kasa ve contalarla üretilir.',
  },
  {
    q: 'Lightbox Baskısı Değiştirilebilir mi?',
    a: 'Evet, lightbox baskıları kolayca değiştirilebilir. Promosyon dönemi, mevsimsel kampanya veya marka güncellemelerinde sadece baskıyı yenileyerek kasayı uzun yıllar kullanabilirsiniz. Baskı yenileme hizmetimiz mevcuttur.',
  },
  {
    q: 'Minimum Sipariş Adedi Nedir?',
    a: 'Minimum sipariş adedimiz 1 adettir. Tek kutu lightboxtan büyük ölçekli projelere kadar her miktarda üretim yapıyoruz. Toplu siparişlerde özel fiyat avantajları sunulmaktadır.',
  },
  {
    q: 'Üretim ve Montaj Süresi Ne Kadar?',
    a: 'Standart lightbox modellerimizde üretim süresi 3-5 iş günüdür. Özel tasarım ve büyük ölçekli projelerde bu süre 7-10 iş gününe uzayabilir. Montaj süresi ürün ve konuma göre genellikle aynı gün tamamlanmaktadır.',
  },
  {
    q: 'İzmir\'de Keşif Hizmeti Veriyor musunuz?',
    a: 'Evet, İzmir ve çevre ilçelerinde ücretsiz keşif hizmeti sunuyoruz. Yerimize gelerek ölçü alıyor, mekânınıza en uygun çözümü öneriyoruz. Keşif randevusu için telefon veya WhatsApp üzerinden bize ulaşabilirsiniz.',
  },
  {
    q: 'Türkiye\'nin Her Yerine Teslimat Yapıyor Musunuz?',
    a: 'Evet, Türkiye\'nin tüm illerine kargo ve nakliye ile teslimat yapıyoruz. Büyük ölçekli projelerde Türkiye genelinde kurulum ekibimiz ile hizmet verebiliyoruz.',
  },
  {
    q: 'Garanti Süresi Nedir?',
    a: 'Tüm lightbox ürünlerimiz 2 yıl garanti kapsamındadır. LED aydınlatma sistemleri için 3 yıl garanti sunulmaktadır. Garanti kapsamında üretim hatası ve malzeme kusurları ücretsiz olarak giderilmektedir.',
  },
  {
    q: 'Özel Ölçü ve Tasarımda Üretim Yapıyor Musunuz?',
    a: 'Evet, tamamen özel ölçü, şekil ve tasarımda lightbox üretimi yapıyoruz. Müşterilerimizin ihtiyaçlarına göre özel çözümler geliştiriyor, tasarım sürecinde de destek sağlıyoruz.',
  },
  {
    q: 'Fiyat Teklifi Nasıl Alabilirim?',
    a: 'WhatsApp hattımızdan mesaj göndererek veya telefon numaramızı arayarak fiyat teklifi alabilirsiniz. Ölçü, adet ve tasarım bilgilerini paylaşmanız durumunda 24 saat içinde size özel fiyat teklifi hazırlıyoruz.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-3">
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
            SSS
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
          </div>
          <h2 className="text-4xl font-black text-gray-900 mb-4">Sıkça Sorulan Sorular</h2>
          <p className="text-gray-500 text-base">
            Lightbox hakkında merak ettiğiniz her şey burada.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-300 ${
                open === i ? 'border-red-200 bg-red-50/50' : 'border-gray-200 bg-white'
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <h3 className={`font-bold text-base ${open === i ? 'text-red-600' : 'text-gray-900'}`}>
                  {faq.q}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ml-4 transition-colors ${
                  open === i ? 'bg-red-600 text-white' : 'bg-gray-100 text-gray-500'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
